import React from 'react';
import { useServicesContext } from '../../../context';
import { FilterContext } from '../FilterContext';
import { useClearAllDealerFilters } from '../FilterContextHooks';
import { useI18n } from '@oneaudi/i18n-context';
import { ZeroResultsBannerWrapper } from '../styles/LocationFilter.styles';
import { setLocationFilterToDefaultState } from '../utils/locationFilterHelpers';
import { TextButton, Text, Headline, } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { DynamicComponent, dynamicStylingHelper, DynamicThemeProviderWrapper } from '../../utils';
export const ZeroResultsBanner = ({ inputRef, isDisplayedOnMapTab, }) => {
    const { getConfiguration, getEnvironmentConfig } = useServicesContext();
    const clearAllDealerFilters = useClearAllDealerFilters();
    const context = React.useContext(FilterContext);
    const zeroResultHeadline = useI18n({
        id: `nemo.sc.filter.locationfilter.zeroResultsHeadline`,
        defaultMessage: 'Your search returned no results.',
    });
    const zeroResultBody = useI18n({
        id: `nemo.sc.filter.locationfilter.zeroResultsBody`,
        defaultMessage: 'Please change your filter selection to find a suitable dealer.',
    });
    const zeroResultButton = useI18n({
        id: `nemo.sc.filter.locationfilter.zeroResultsButton`,
        defaultMessage: 'Reset location filter',
    });
    return (React.createElement(DynamicThemeProviderWrapper, null,
        React.createElement(ZeroResultsBannerWrapper, { isDisplayedOnMapTab: isDisplayedOnMapTab },
            React.createElement(DynamicComponent, { legacy: React.createElement(StyledHeadline, { tag: "h4", variant: {
                        order: '1',
                        type: 'copy',
                        weight: 'normal',
                    } }, zeroResultHeadline) }),
            React.createElement(DynamicComponent, { alpha: React.createElement(StyledText, { tag: "p", variant: {
                        order: '1',
                        style: 'normal',
                        type: 'copy',
                    } }, zeroResultHeadline) }),
            React.createElement(StyledText, { tag: "p", variant: {
                    order: dynamicStylingHelper('2', '3'),
                    style: 'normal',
                    type: 'copy',
                } }, zeroResultBody),
            React.createElement(StyledTextButton, { icon: "forward", variant: "tertiary", iconPosition: "trailing", size: "sm", onClick: () => setLocationFilterToDefaultState(getConfiguration(), getEnvironmentConfig(), clearAllDealerFilters, context, inputRef), isLegacy: dynamicStylingHelper(true, false) }, zeroResultButton))));
};
export default ZeroResultsBanner;
const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  margin-bottom: var(--spacing-relative-md);
`;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  margin-bottom: var(--spacing-relative-md);
`;
const StyledTextButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  padding: ${(props) => props.isLegacy && '0px'};
`;
